module.exports = "<span class=\"text\" [style.color]=\"getColor()\" ]>\n  {{message}}\n</span>\n"